import {
  getSuggestionBasedOn,
  isSuggestedByShipper,
} from 'shared/modules/load-suggestions/core/LoadSuggestionsAnalytics';
import { LoadSuggestionDTO } from 'shared/modules/load-suggestions/data/LoadSuggestionDTO';
import { PostingDTO } from '../data/dto/PostingDTO';
import {
  isEmptyCriteria,
  PostingsPageParamsDTO,
} from '../data/dto/PostingsPageParamsDTO';
import {
  DriverSuggestedLoadOpenSource,
  trackLoadboardEvent,
} from './LoadboardAnalytics';

export function getDriverSuggestedLoadOpenSource(
  params: PostingsPageParamsDTO,
): DriverSuggestedLoadOpenSource | undefined {
  // Load Alert results are not part of the suggested loads funnel.
  if (params.current_saved_search_guid) {
    return undefined;
  }

  // `isEmptyCriteria` already limits search results to the tabs that can show
  // them, so stale criteria on other tabs do not get reported as "Search".
  if (!isEmptyCriteria(params)) {
    return 'Search';
  }

  switch (params.current_tab) {
    case 'available':
      return 'Available Tab';
    case 'suggested':
      return 'Suggested Tab';
    case 'saved-loads':
      return 'Saved Tab';
    default:
      return undefined;
  }
}

export function trackDriverOpenedPostingIfSuggested(
  posting: PostingDTO,
  utmMedium: DriverSuggestedLoadOpenSource | undefined,
  utmContent?: string,
) {
  if (posting.suggestion_id == null || !utmMedium) {
    return;
  }

  trackLoadboardEvent({
    name: 'Driver Opened Suggested Load',
    utm_medium: utmMedium,
    utm_content: utmContent,
    load_guid: posting.load.guid,
    posting_guid: posting.load.posting_guid,
    suggestion_id: posting.suggestion_id,
    suggested_by_shipper: !!posting.is_shipper_recommended,
  });
}

export function trackDriverOpenedSuggestion(
  load: LoadSuggestionDTO,
  utmMedium: DriverSuggestedLoadOpenSource,
) {
  trackLoadboardEvent({
    name: 'Driver Opened Suggested Load',
    utm_medium: utmMedium,
    load_guid: load.guid,
    posting_guid: load.posting_guid,
    suggestion_id: load.suggestion_id,
    load_suggestion_guid: load.suggestion_guid,
    suggestion_based_on: getSuggestionBasedOn(load),
    suggested_by_shipper: isSuggestedByShipper(load),
  });
}
